
import DateFormat from '../common/dateFormat/DateFormat';

const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaUnidade: [],
	listaProduto: [],
	listaDistribuidora: [],
	filtro: {
		data: DateFormat.formatarDataSqlParaTela(DateFormat.getDataAtual())
	}
};


export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'POLITICA_PRECO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};
		
		case 'POLITICA_PRECO_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

		case 'POLITICA_PRECO_FILTRO':
            return { ...state,
				filtro: action.payload
			};

        case 'POLITICA_PRECO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'POLITICA_PRECO_UNIDADE_SELECT_LISTADO':
			return {
				...state,
				listaUnidade: action.payload.data
			};

		case 'POLITICA_PRECO_PRODUTO_SELECT_LISTADO':
			return {
				...state,
				listaProduto: action.payload.data
			};

		case 'POLITICA_PRECO_DISTRIBUIDORA_SELECT_LISTADO':
			return {
				...state,
				listaDistribuidora: action.payload.data
			};

        default:
            return state;
    }
}
